import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: 100,
  },
  emptyIcon: {
    fontSize: 60,
    color: '#878787',
    paddingBottom: 40,
  },
  emptyTitle: {
    marginBottom: 10,
  },
  emptyDescription: {
    width: 160,
    textAlign: 'center',
  },
});
